export default __webpack_public_path__ + "static/media/Hape-alphabet-peg-puzzle.76947212.jpg";